import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import { useAppSelector } from 'src/app/hooks';
import { useTheme } from '@mui/material/styles';

import AsmubipButton from './AsmubipButton';
import FormStepper from './FormStepper';

export default function BottomBarForm({ page }: { page: number }) {
  const theme = useTheme();
  const { formDisabled, formWizard, formIsValid } = useAppSelector((state) => state.page);

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        top: 'auto',
        bottom: 0,
        backgroundColor: theme.palette['surface-background'].main,
        py: 2,
      }}>
      <Toolbar>
        {formWizard ? (
          <FormStepper {...formWizard} isValid={formIsValid} page={page} />
        ) : (
          <AsmubipButton
            variant="contained-bottom-bar"
            aria-label="salvar"
            type="submit"
            disabled={formDisabled}>
            Concluir
          </AsmubipButton>
        )}
      </Toolbar>
    </AppBar>
  );
}
